

export class LocalServerStatus {

    HasService: boolean;
    HasGui: boolean;
  LastChecked: Date;
}
